import { lang } from '../../assets/lang'
import { sequenceSingleHours, sequenceSingleDays } from '../../data'
import { getSelectOptionsFromArrayOfObjects } from '../../functions/utils'

export const sequenceSingleHtml =
'<div class="row mt-2">' +
  '<div class="col-6 pr-2">' +
    '<div class="form-group text-left">' + 
      '<label for="sequence-single-promotional">' + lang.sequence_single_html_label_promotional + '</label>' +
      '<div class="custom-switches-stacked mt-2">' +
        '<label class="custom-switch">' +
          '<input type="radio" name="sequence-single-radio" value="1" id="sequence-single-promotional" class="custom-switch-input">' +
          '<span class="custom-switch-indicator"></span>' +
          '<span class="custom-switch-description">' + lang.sequence_single_html_title_hours_24 + '</span>' +
        '</label>' +
      '</div>' +  
    '</div>' +
  '</div>' +
  '<div class="col-6 pl-2">' +
    '<div class="form-group text-left">' + 
    '<label for="sequence-single-non-promotional">' + lang.sequence_single_html_label_non_promotional + '</label>' +
      '<div class="custom-switches-stacked mt-2">' +
        '<label class="custom-switch">' +
          '<input type="radio" name="sequence-single-radio" value="2" id="sequence-single-non-promotional" class="custom-switch-input">' +
          '<span class="custom-switch-indicator"></span>' +
          '<span class="custom-switch-description">' + lang.sequence_single_html_title_daily + '</span>' +
        '</label>' +
      '</div>' +
    '</div>' +
  '</div>' +
'</div>' +

'<div id="sequence-single-hours-group" class="button-onDemand-field form-group text-left mt-2">' + 
  '<label for="sequence-single-hours">' + lang.sequence_single_html_label_hours + '</label>' +
  '<select id="sequence-single-hours" class="form-control select2">' +
    '<option value="" selected>' + lang.sequence_single_html_title_select + '</option>' +
    getSelectOptionsFromArrayOfObjects(sequenceSingleHours) +
  '</select>' +
'</div>' +

'<div id="sequence-single-days-group" class="button-onDemand-field form-group text-left mt-2">' + 
  '<label for="sequence-single-days">' + lang.sequence_single_html_label_days + '</label>' +
  '<select id="sequence-single-days" class="form-control select2">' +
    '<option value="" selected>' + lang.sequence_single_html_title_select + '</option>' +
    getSelectOptionsFromArrayOfObjects(sequenceSingleDays) +
  '</select>' +
'</div>'
